export default __webpack_public_path__ + "static/media/database-solid.51312a7a.svg";